<script>
import TreeTable from "@/components/tree-table/TreeTable.vue";
import {request} from "@/config/request";
import {handleBuildTreeData} from "@/utils/levelUtils";
import {resetEmpty} from "@/utils/common";

/*
* 在“食材-编辑元素”功能中：用户可自由选择或取消特定元素，并支持一键全选。
* 若在元素管理页面开启“默认展示”功能，相关元素将自动设置为默认选项，新增食谱时会自动勾选。
* */

export default {
  name: "SelectElTable",
  components: {TreeTable},
  props: {
    // 已添加元素列表
    list: {
      type: Array,
      default: () => ([])
    },
    foodCode: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showDialog: false,
      searchForm: {},
      listData: [],
      expandState: true,

      columnList: [
        {label: "营养素名称", prop: "name", fixed: "left"},
        {label: "英文名", prop: "enName"},
        {label: "默认展示", prop: "display"},
        {label: "创建时间", prop: "createTimeStr"},
      ],

      vxeTable: null,
    }
  },
  methods: {
    resetEmpty,

    handleShowDialog() {
      this.showDialog = true;
      this.$nextTick(() => {
        this.vxeTable = this.$refs.treeTable.getTableRef();
        this.handleSearch();
      })
    },

    // 搜索数据
    async handleSearch() {
      try {
        const params = {
          ...this.searchForm,
          onPage: false,
        }
        let res = await request(this.$api.elementSort.list, params);
        this.listData = handleBuildTreeData(res.elementSorts, item => {
          return {
            createTimeStr: this.$moment(item.createTime).format("YYYY-MM-DD HH:mm:ss"),
          }
        });
        this.$nextTick(() => {
          const selectElCodes = this.buildElCodes(this.list);
          this.handleSelectedByDisplay(selectElCodes);
        })
      } catch (e) {
        console.error(e);
      }
    },

    // 构建codes
    buildElCodes(targetList) {
      const codes = [];
      const fn = (list) => {
        list.forEach(item => {
          codes.push(item.elementCode)
          if(item.sub && item.sub.length) {
            fn(item.sub);
          }
        })
      }
      fn(targetList);
      return codes;
    },

    // 默认展示需要自动勾选
    handleSelectedByDisplay(selectElCodes) {
      const fn = (list) => {
        list.forEach(item => {
          if (item.sub.length) {
            fn(item.sub);
          }
          if (item.display === "yes" || selectElCodes.includes(item.code)) {
            this.vxeTable.setCheckboxRow(item, true);
          }
        })
      }
      fn(this.listData);
    },


    // 添加元素
    async handleConfirm() {
      const records = this.vxeTable.getCheckboxRecords();
      if (!records.length) {
        this.$message.warning(this.$t('请选择需要添加的元素'));
        return;
      }
      try {
        const params = this.handleFormatAddElData(records);
        await request(this.$api.foodElement.save, params, {isJson: true});
        this.$message.success(this.$t('添加成功'));
        this.$emit("refresh");
        this.showDialog = false;
      } catch (e) {
        console.log(e);
      }
    },

    handleFormatAddElData(selectedList) {
      const fn = (list) => {
        return list.map((item, index) => {
          const targetItem = {
            foodCode: this.foodCode,
            elementCode: item.code,
            content: null,
            expand: item.expand,
            display: item.display,
            sort: index + 1,
            foodElementBeans: [],
          }

          // 是否已添加过该元素，如果是则取已添加的元素code
          if(this.selectElList.has(item.code)) {
            targetItem["code"] = this.selectElList.get(item.code).code;
          }

          if(item.sub.length) {
            targetItem.foodElementBeans = fn(item.sub);
          }
          return targetItem;
        })
      }

      return {
        foodCode: this.foodCode,
        foodElementBeans: fn(selectedList),
      }
    },

    // 构建一个Map, 用于快速查找元素
    buildElMap(targetList, targetKey) {
      //  key: 元素 targetKey value: item
      const elMap = new Map();
      const fn = (list) => {
        list.forEach(item => {
          elMap.set(item[targetKey], item);
          if(item.sub && item.sub.length) {
            fn(item.sub);
          }
        })
      }
      fn(targetList);
      return elMap;
    },
  },
  computed: {
    selectElList() {
      return this.buildElMap(this.list, "elementCode");
    }
  }
}
</script>

<template>
  <el-dialog :visible.sync="showDialog" :close-on-click-modal="false" :title="$t('编辑元素')">
    <el-form inline size="small">
      <el-form-item :label="$t('营养素名称')">
        <el-input :placeholder="$t('营养素名称')" v-model="searchForm.name" clearable />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="resetEmpty()">{{$t('重置')}}</el-button>
      </el-form-item>
    </el-form>
    <tree-table :column-list="columnList"
                :data.sync="listData"
                :show-add="false"
                :expand.sync="expandState"
                :height="600"
                ref="treeTable"
                :maxLevel="2">

      <template #display="{row}">
        {{row.display === "yes" ? $t('是') : $t('否')}}
      </template>
    </tree-table>

    <template #footer>
      <el-button size="small" type="primary" @click="handleConfirm">{{$t('确定')}}</el-button>
      <el-button size="small" @click="showDialog = false">{{$t('关闭')}}</el-button>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
